import { ResourceIdentifier } from "../ResourceManager/ResourceIdentifier";
import {ITimeout , TimingCallback} from "./Timeout";
import { safeClearTimeout, safeSetTimeout } from "./SafeTiming";
export interface IRandomTimeout extends ITimeout
{
    ChangeTimeoutFromTo(timeoutFrom: number, timeoutTo: number): void;
}


export class RandomTimeout implements IRandomTimeout
{
    protected resid: ResourceIdentifier;

    protected running: boolean = false;
    protected timeoutid: number = 0;

    protected callback: TimingCallback = null;
    protected timeoutFrom: number = 0;
    protected timeoutTo: number = 0;
    protected currentTimeout: number = 0;

    public constructor(resid: ResourceIdentifier, callback: TimingCallback, timeoutFrom: number, timeoutTo: number)
    {

        this.resid = resid;

        if (callback == null) throw "callback must not be null";
        this.callback = callback;

        this.ChangeTimeoutFromTo(timeoutFrom, timeoutTo);
    }
    ChangeTimeout(timeout: number) {
        //throw new Error("Method not implemented.");
    }

    public GetTimeout(): number {
        return this.currentTimeout;
    }

    // public get Timeout(): number
    // {
    //     return this.timeout;
    // }

    // public set Timeout(timeoutMillis: number)
    // {
    //     if (timeoutMillis < 0) throw "timeoutMillis must not be negative";

    //     this.timeout = timeoutMillis;
    // }

    // public Timeout(): number
    // {
    //     return this.currentTimeout;
    // }

    protected TimeoutTriggered(): void
    {
        this.running = false;
        this.timeoutid = -1;

        this.callback();
    }

    public ChangeTimeoutFromTo(timeoutFrom: number, timeoutTo: number): void
    {
        if (timeoutFrom < 0) throw "timeoutFrom must not be negative";
        if (timeoutFrom > timeoutTo) throw "timeoutFrom must be smaller than timeoutTo";

        this.timeoutFrom = timeoutFrom;
        this.timeoutTo = timeoutTo;
    }

    // starts or restarts timer
    public Start(): void
    {
        if (this.running)
        {
            this.Stop();
        }

        this.running = true;

        this.currentTimeout = Math.floor(Math.random() * (this.timeoutTo - this.timeoutFrom)) + this.timeoutFrom;
        //console.log("CurrentIntervalTimeForAnim: ",this.currentTimeout);
        this.timeoutid = safeSetTimeout(() => this.TimeoutTriggered(), this.currentTimeout);
    }

    public Restart(): void
    {
        this.Start();
    }

    public Stop(): void
    {
        if (this.running)
        {
            this.running = false;
            safeClearTimeout(this.timeoutid);
        }
    }

    public Running(): boolean
    {
        return this.running;
    }

    public Name(): string
    {
        return this.resid.ID();
    }
}